import React, { Component } from 'react';
import { get, isEmpty } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import DietTypeNextStepButton from "./dietTypeNextStepButton"
import SwitcherWrapper from "../../../shared/items/controls/switcherWrapper"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { dietTypeData } from "./static.dietTypeData"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"
import fixFocus from "./../../../utils/fixFocus"
import "./../../../shared/services/service.step.scss"
import styles from "./dietType.module.scss"

class DietType extends Component {
  constructor() {
    super();

    this.state = {
      isOpenDietType: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.dietType) && !this.state.isOpenDietType)
      this.setState({ isOpenDietType: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenDietType } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.dietType,
      isOpen: isOpenDietType,
      handleChange: this.handleChangeOpen.bind(this),
    }
    if (isOpenDietType && isEmpty(data.dietType)) {
      onSetStepData("dietType");
      fixFocus();
    }
      
    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenDietType: state,
    });

  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenDietType } = this.state
    const params = {
      className: "wrapperDietType",
      currentIndex: currentIndex,
      stepIndex: steps.dietType,
    }

    return isOpenDietType ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].diet_type}</FirstTitle>

          {
            Object.keys(dietTypeData).map((key, index) => {
              return (
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["dietType", "value"], null) === dietTypeData[key].value}
                  onClick={() => {
                    if (get(data, ["dietType", "value"], null) !== dietTypeData[key].value) {
                      onUpdateStepData.bind(this, "dietType", "value", dietTypeData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                  icon={dietTypeData[key].icon}
                >
                  {dietTypeData[key].title}
                </RadioCheckButton>
              )
            })
          }

          <div className={styles.container_fasting}>
            <SwitcherWrapper
              name="fasting"
              label={locales[window.userLang].intermittent_fasting}
              checked={get(data, ["dietType", "fasting"], null)}
              onChange={onUpdateStepData.bind(this, "dietType")}
            />
          </div>
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(DietType);